import React, { useState, useEffect,useContext } from "react";
import { Grid, Card, CardContent, Typography, Box,Button,CardMedia } from "@mui/material";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import "./EmployeeView.css";
import config from "config/config";
import Context from "context/context";
import { toast } from "react-toastify";
import ReusableTable from "components/table/table";
import Tooltip from '@mui/material/Tooltip';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import selfassessment from 'assets/images/selfassesment.png'
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { ToastContainer} from 'react-toastify';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab} from '@mui/material';
import History from './History';


import {
    
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    
  } from "@mui/material";

const EmployeeView = () => {
    
    const [employeeCycles, setEmployeeCycles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCycle, setSelectedCycle] = useState(null);
    const [templateData, setTemplateData] = useState([]);
    const [isTemplateLoading, setIsTemplateLoading] = useState(false);
    const [offset, setOffset] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [formattedTemplateData, setFormattedTemplateData] = useState([]);
    const [assignedGoals, setAssignedGoals] = useState([]);
    const { state, dispatch } = useContext(Context);
  const [count, setCount] = useState(0); // Add a count for pagination
  const [appraisalCycleId, setAppraisalCycleId] = useState(null);
  const [hasInitialized, setHasInitialized] = useState(false);
  const [value, setValue] = useState("1");


  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({
    kraCategory: "",
    kpiName: "",
    selfRating: "",
    justification: "",
  });
  const [originalData, setOriginalData] = useState({
    selfRating: "",
    justification: "",
  });

  
    const defaultCycles = ["Q1", "Q2", "Q3", "Q4", "Yearly"];
  
    useEffect(() => {
      fetchAppraisalCycles();
    }, []);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

  
  
    const fetchAppraisalCycles = async () => {
      try {
        dispatch({ type: "SET_LOADING", payload: true });
        const url = `${config.host}/panel/pms/employee/allAppraisalCycles`;
        const response = await fetch(url, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
  
        if (!response.ok) {
          throw new Error("Error fetching appraisal cycles");
          dispatch({ type: "SET_LOADING", payload: false });
        }
  
        const data = await response.json();
  
        if (data.status === "Ok" && Array.isArray(data.data.employeeCycles)) {
          const sortedCycles = defaultCycles
            .map((cycleName) =>
              data.data.employeeCycles.find((item) => item.cycleName === cycleName)
            )
            .filter(Boolean); 
          setEmployeeCycles(sortedCycles);
          dispatch({ type: "SET_LOADING", payload: false });
        } else {
          console.error("Unexpected data format:", data);
        }
      } catch (error) {
        console.error("Error fetching appraisal cycles:", error);
        dispatch({ type: "SET_LOADING", payload: false });
      } finally {
        dispatch({ type: "SET_LOADING", payload: false });
      }
    };
  
    const fetchTemplateData = async (appraisalId) => {
        dispatch({ type: "SET_LOADING", payload: true });
        setIsTemplateLoading(true);
        try {
          const url = `${config.host}/panel/pms/employee/template?appraisalId=${appraisalId}`;
          const response = await fetch(url, {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          });
    
          if (!response.ok) {
            throw new Error("Error fetching template data");
            dispatch({ type: "SET_LOADING", payload: false });
          }
    
          const data = await response.json();
    
          if (data.status === "Ok" && Array.isArray(data.data)) {
            const formattedDataView = data.data.flatMap((employee, index) =>
              employee.kpiDetails.map((kpi, kpiIndex) => ({
                id: kpi.kpiKraDetailsId,
                employeeAssessmentsId: employee.employeeAssessmentsId,
                index: kpiIndex + 1, 
                kpiName: kpi.kpiName,
                weightage: kpi.weightage,
                kraCategory: kpi.kraCategory,
                templateName: employee.templateName,
                selfRating: kpi.selfRating , 
                justification: kpi.justification , 
              }))
            );
            setAssignedGoals(formattedDataView); 
            dispatch({ type: "SET_LOADING", payload: false });
          }
        } catch (error) {
          console.error("Error fetching template data:", error);
          toast.error("Failed to fetch assigned goals");
        } finally {
            dispatch({ type: "SET_LOADING", payload: false });
        }
      };
    
      const tableDataModal = assignedGoals.map((employee) => [
        employee.index, // S.No
        employee.kraCategory,
        employee.kpiName,
        employee.weightage,
        <Tooltip title="Click to give review" key={employee.id}>
          <span className="jobType">
            <RemoveRedEyeIcon
              style={{ color: '#E97000', cursor: 'pointer' }}
              onClick={() => handleViewClick(employee)} 
            />
          </span>
        </Tooltip>,
      ]);
    
     
  
    const handleCardClick = (cycle) => {
        if (cycle.employeeStatus === "Completed") {
            toast.info("Self-assessment has been completed for this cycle.");
            return; 
          }
        setAppraisalCycleId(cycle.cycleId);
      setSelectedCycle(cycle);
      fetchTemplateData(cycle.cycleId);
    };
  
    const handleBack = () => {
      setSelectedCycle(null);
      setTemplateData([]);
    };
    const handleViewClick = (employee) => {
        if (!employee) {
          console.error("Invalid employee data:", employee);
          return;
        }
      
        setModalData({
          kraCategory: employee.kraCategory || "",
          kpiName: employee.kpiName || "",
          selfRating: employee.selfRating || "", 
      justification: employee.justification || "", 
          employeeAssessmentsId: employee.employeeAssessmentsId, // Add assessment ID
        kpiKraId: employee.id,
        });
        setOpenModal(true);
      };
    
      const handleModalClose = () => {
        setOpenModal(false);
       
      };

      const handleAssessmentSave = async () => {
        const missingFields = assignedGoals.some((goal) => !goal.selfRating || !goal.justification);
        
        if (missingFields) {
            toast.error("Please provide both rating and justification for all KPIs.");
            return; 
        }
        
        const employeeAssessmentsId = assignedGoals[0]?.employeeAssessmentsId; 
        if (!employeeAssessmentsId) {
            toast.error("Employee Assessment ID is missing.");
            return;
        }
    
        try {
            dispatch({ type: "SET_LOADING", payload: true });
            const response = await fetch(`${config.host}/panel/pms/employee/saveAssessments`, {
                method: "POST",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    employeeAssessmentsId: employeeAssessmentsId,
                }),
            });
    
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Failed to save assessments.");
                dispatch({ type: "SET_LOADING", payload: false });
            }
    
            const data = await response.json();
    
            if (data.status === "Ok" && data.data.updated > 0) {
                toast.success("Assessment Submited Successfully!");
                setSelectedCycle(null);
                fetchAppraisalCycles();
                dispatch({ type: "SET_LOADING", payload: false });

                
            } else {
                toast.error("No changes were made. Try again.");
                dispatch({ type: "SET_LOADING", payload: false });
            }
        } catch (error) {
            console.error("Error Submitting Assessment:", error);
            toast.error(`Error: ${error.message}`);
            dispatch({ type: "SET_LOADING", payload: false });
        }
    };
    
    
      const handleModalSave = async () => {
     
        if (!modalData.selfRating || modalData.selfRating === "Pending"|| !modalData.justification) {
            toast.error("Both rating and justification are required.");
            return;
        }
          
          dispatch({ type: "SET_LOADING", payload: true }); 
      
        try {
          const response = await fetch(`${config.host}/panel/pms/employee/assessment`, {
            method: "POST",
            credentials: "include", 
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              employeeAssessmentsId: modalData.employeeAssessmentsId,
              employeeId: modalData.employeeId,
              selfRating: modalData.selfRating,
              justification: modalData.justification,
              kpiKraId: modalData.kpiKraId,
            }),
          });
      
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to save the self-review");
          }
      
          const data = await response.json();
      
          if (data.status === "Ok") {
            toast.success("Self-review saved successfully!");
            console.log("Saved Employee Assessment ID:", modalData.employeeAssessmentsId);
      
            fetchTemplateData(appraisalCycleId); 
          } else {
            toast.error("Failed to save the self-review.");
          }
        } catch (error) {
          console.error("Error saving self-review:", error);
          toast.error(`Error: ${error.message}`);
        } finally {
          dispatch({ type: "SET_LOADING", payload: false }); 
          handleModalClose(); 
        }
      };
      
  
   
  
    return (
      <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="HR View Tabs">
              <Tab label="Self Assessment" value="1" className={value === '1' ? 'Leave' : 'nonleaveTab'} />
              <Tab label="History" value="2" className={value === '2' ? 'Leave' : 'nonleaveTab'} />
            </TabList>
          </Box>
          <TabPanel value="1">
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />

            {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '100%', overflowX: 'auto' }}> */}
        <Typography
          variant="h5"
          align="center"
          className="self-title"
          
        >
          {selectedCycle ? `Employee Self Assessment-${selectedCycle.cycleName}` : "Appraisal Cycle"}
        </Typography>
  
        {selectedCycle ? (
      <>
        <Button
          variant="contained"
          onClick={handleBack}
          sx={{ marginBottom: 2 }}
        >
          Back
        </Button>
        <ReusableTable
          create={
            <Button className="AddKrabutton" onClick={handleAssessmentSave}>
              Submit
            </Button>
          }
          data={tableDataModal}
          count={assignedGoals.length}
          offset={offset}
          setOffset={setOffset}
          limit="25"
          setSearchValue={setSearchValue}
          heading={["S.No", "KRA", "KPI", "Weightage", "Action"]}
        />
      </>
    ) : employeeCycles.length > 0 ? (
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
        {employeeCycles.map((cycle) => (
          <Card
            className="card-style"
            key={cycle.assessmentTemplateId}
            style={{
              width: "200px",
              margin: "20px",
              padding: "20px",
              textAlign: "center",
              cursor: cycle.isActive ? "pointer" : "not-allowed",
              height: "250px",
              position: "relative",
              boxShadow: cycle.isActive
                ? "0px 4px 20px rgba(0, 0, 0, 0.1)"
                : "0px 4px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "10px",
              opacity: cycle.isActive ? 1 : 0.5,
            }}
            onClick={() => {
              if (cycle.isActive) {
                handleCardClick(cycle); 
              }
            }}
          >
            <CardMedia
              component="img"
              height="150"
              image={selfassessment}
              alt="Saved Template"
            />
            <CardContent>
              <Typography variant="h6" className="template-name">
                {cycle.templateName}
              </Typography>
              <Typography className="template-quarter" style={{ textAlign: "center" }}>
                {(() => {
                  const startDate = cycle.assessmentStartDate
                    ? new Date(cycle.assessmentStartDate)
                    : null;
                  const endDate = cycle.assessmentEndDate
                    ? new Date(cycle.assessmentEndDate)
                    : null;

                  if (startDate) {
                    const month = startDate.getMonth();
                    const quarter = `Q${Math.floor(month / 3) + 1}`;

                    const formattedStartDate = startDate.toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                    });
                    const formattedEndDate = endDate
                      ? endDate.toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                        })
                      : "N/A";

                    return (
                      <>
                        <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                          {quarter}
                        </div>
                        <div style={{ fontSize: "0.9rem" }}>
                          {formattedStartDate} - {formattedEndDate}
                        </div>
                      </>
                    );
                  }

                  return "N/A";
                })()}
              </Typography>
            </CardContent>
            {cycle.employeeStatus === "Completed" && (
              <CheckCircleIcon
                sx={{
                  position: "absolute",
                  bottom: "10px",
                  right: "10px",
                  color: "#4caf50",
                  fontSize: "30px",
                }}
              />
            )}
          </Card>
        ))}
      </div>
    ) : (
      <Typography variant="body1" align="center">
        No appraisal cycles available.
      </Typography>
    )}

</TabPanel>
          <TabPanel value="2">
            <History/>
          </TabPanel>
          <TabPanel value="3">
          </TabPanel>
        </TabContext>
     <Dialog
  open={openModal}
  onClose={handleModalClose}
  maxWidth={false}
  classes={{
    paper: "self-modal-paper",
  }}
>
  <DialogTitle className="self-modal-title">Self Review</DialogTitle>
  <Grid container spacing={2} sx={{ pl: 6, pr: 5, pb: 5, mt: 2 }}>
  {/* KRA */}
  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
    <Box className="label">KRA <span style={{ color: "red" }}>*</span></Box>
    <TextField
      sx={{ border: "1px solid #B2D4F8" }}
      id="kraCategory"
      name="kraCategory"
      placeholder="Enter KRA"
      variant="outlined"
      fullWidth
      value={modalData.kraCategory}
      InputProps={{ readOnly: true }} // Make it readonly
    />
  </Grid>

  {/* KPI */}
  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
    <Box className="label">KPI <span style={{ color: "red" }}>*</span></Box>
    <TextField
      sx={{ border: "1px solid #B2D4F8" }}
      id="kpiName"
      name="kpiName"
      placeholder="Enter KPI"
      variant="outlined"
      fullWidth
      value={modalData.kpiName}
      InputProps={{ readOnly: true }} // Make it readonly
    />
  </Grid>

  {/* Self Rating */}
  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
    <Box className="label">Self Rating<span style={{ color: "red" }}>*</span></Box>
    <FormControl fullWidth>
      <Select
        labelId="self-rating-label"
        id="selfRating"
        style={{ border: "2px solid #B2D6F8", color: "grey" }}
        value={modalData.selfRating}
        onChange={(e) => setModalData((prev) => ({ ...prev, selfRating: e.target.value }))}
        displayEmpty
      >
        <MenuItem value="" disabled>Select rating</MenuItem>
        <MenuItem value="Outstanding">Outstanding</MenuItem>
        <MenuItem value="Exceeds Expectation">Exceeds Expectation</MenuItem>
        <MenuItem value="Met Expectation">Met Expectation</MenuItem>
        <MenuItem value="Met Expectation, but needs improvement">
          Met Expectation, but needs improvement
        </MenuItem>
        <MenuItem value="Does not meet expectation">
          Does not meet expectation
        </MenuItem>
      </Select>
    </FormControl>
  </Grid>

  {/* Justification */}
  <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
    <Box className="label">Justification<span style={{ color: "red" }}>*</span></Box>
    <TextField
      sx={{ border: "1px solid #B2D4F8" }}
      id="justification"
      name="justification"
      placeholder="Enter Justification"
      variant="outlined"
      fullWidth
      multiline
      rows={4}
      value={modalData.justification}
      onChange={(e) => setModalData((prev) => ({ ...prev, justification: e.target.value }))}
    />
  </Grid>
</Grid>

  <DialogActions>
    <Button onClick={handleModalClose} className="self-cancelButton">
      Cancel
    </Button>
    <Button onClick={handleModalSave} className='self-saveButton'>
      Save
    </Button>
  </DialogActions>
</Dialog>


    </Box>
    </div>
  );
};

export default EmployeeView;
    
